export default function isInstance(object) {
  return object && object instanceof this;
}
